export const SHOWCASE = 'showcase'
export const SHOWCASEREDUCED = 'showcaseReduced'
export const FLYER = 'flyer'
export const NEWSPAPER = 'newspaper'
export const WEEKPOSTER = 'weekposter'
export const WEEKPROGRAMFLYER = 'weekProgramFlyer'

export const LETTER = 'Letter'
export const LEGAL = 'Legal'
export const TABLOID = 'Tabloid'
export const LEDGER = 'Ledger'
export const SPECIAL = 'Special'
export const A0 = 'A0'
export const A1 = 'A1'
export const A2 = 'A2'
export const A3 = 'A3'
export const A4 = 'A4'
export const A5 = 'A5'
export const A6 = 'A6'